// extracted by mini-css-extract-plugin
export var separator = "Footer-module--separator--4+a7G";
export var main = "Footer-module--main--h24yr";
export var drawing = "Footer-module--drawing--3ezZ-";
export var section = "Footer-module--section--x8kC5";
export var title = "Footer-module--title--11gDf";
export var content = "Footer-module--content--MkL4e";